import $ from "cash-dom";
import {format} from "../systems/format";

export const formComponent = (root, {
    fields,
    onSubmit: onSubmitHandler,
    onErrors: onErrorsHandler
}) => {
    const form = $(root).get(0);

    const getElements = () => Object.fromEntries(
        Array.from(form.elements)
            .filter(e => e.type !== 'radio' || !!e.checked)
            .map(e => [e.name, {value: e.value, checked: e.checked, element: e}])
    );
    const getValues = () => {
        const elements = getElements();
        return Object.fromEntries(
            fields.map(({name, type}) => [
                name,
                format[type](elements[name])
            ])
        );
    };
    const validate = (values) => Object.fromEntries(
        fields.map(({name, validate}) => [name, validate(values[name])])
    );

    const onSubmit = e => {
        e.preventDefault();

        const values = getValues();
        // console.log(values);

        const errors = validate(values);
        // console.log(errors);

        if (!Object.values(errors).reduce((a, i) => a && i, true))
            onErrorsHandler(errors);
        else
            onSubmitHandler(values);
    };

    form.onsubmit = onSubmit;

    const elements = getElements();
    fields.forEach(({name, validate, onInput, onValid}) => {
        if (!elements[name])
            console.warn('Missing element for', name);

        let onInputSup = elements[name].element.oninput;

        elements[name].element.oninput = (e) => {
            const value = getValues()[name];
            console.log(value, onInput, onInputSup);
            if (onInputSup)
                onInputSup(e);
            if (onInput)
                onInput(value, {name, validate, onInput, onValid});
            if (onValid && validate(value))
                onValid(value);
        };

        if (onInput)
            onInput(getValues()[name], {name, validate, onInput, onValid});
    });

    return {
        getValues,
        validate,
        fields,
    };
};
